<template lang="html">
  <v-layout row wrap align-center justify-center class="layout-height">
    <v-progress-circular color="primary" size="100" :indeterminate="progress"></v-progress-circular>
      <checkconsentdialog :checkconsentDialog="checkconsentDialog" :url_consent="url_consent" @closeDialogConsent="closeDialogConsent"></checkconsentdialog>
      <LoginDialog :dialogLogin="dialogLogin" @closeLoginDialog="closeLoginDialog"></LoginDialog>
  </v-layout>
</template>

<script>
import { Decode } from '@/services'
import checkconsentdialog from '@/components/chat/dialog/consent/check_consent_dialog'
import LoginDialog from '@/components/chat/dialog/LoginDialog'
export default {
  data () {
    return {
      progress: false,
      token: '',
      checkconsentDialog: false,
      url_consent: '',
      share_token: '',
      dataConsent: '',
      dialogLogin: false,
    }
  },
  components: {
    checkconsentdialog,
    LoginDialog,
  },
  created () {
    this.progress = true
    if (localStorage.getItem('Authenrization') !== undefined && localStorage.getItem('Authenrization') !== null) {
      var decoded = JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
      this.token = decoded['tokenuser']
      // console.log(this.$route.query.data_consent)
      this.dataConsent = JSON.parse(Decode.decode(this.$route.query.data_consent))
      this.getAccesstoken()
    } else {
      this.dialogLogin = true
    }
  },
  methods: {
    closeLoginDialog () {
      this.dialogLogin = false
      if (localStorage.getItem('Authenrization') !== undefined && localStorage.getItem('Authenrization') !== null) {
        var decoded = JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
        this.token = decoded['tokenuser']
        // console.log(this.$route.query.data_consent)
        this.dataConsent = JSON.parse(Decode.decode(this.$route.query.data_consent))
        this.getAccesstoken()
      }
      else {
        this.dialogLogin = true
      }
      // this.getAccesstoken()
    },
    closeDialogConsent () {
      this.checkconsentDialog = false
      this.progress = true
      this.axios.post(this.dataConsent.endpoint, {
        tax_id: this.dataConsent.tax_id,
        shared_token: this.share_token,
        service_id: this.dataConsent.service_id,
        consent_form_id: this.dataConsent.consent_form_id
      }).then((response) => {
        if (response.data.result === 'success') {
          this.progress = false
          this.url_consent = ''
          if (response.data.data.status !== 'approved') {
            this.url_consent = response.data.data.response.elements.choice.url + this.share_token
            // console.log(response.data.data)
            if (window.innerWidth <= 960) {
              this.$router.push('/mobile/homepage')
            } else {
              this.$router.push('/chat/not_permission')
            }
          } else {
            this.updateConsent(this.dataConsent.bot_id)
            if (window.innerWidth <= 960) {
              this.$router.push('/mobile/room/' + this.$route.params.tokenroom)
            } else {
              this.$router.push('/chat/room/' + this.$route.params.tokenroom)
            }
          }
        }
      }).catch(error => {
        console.log(error)
      })
    },
    getAccesstoken () {
      this.progress = true
      this.axios.post(process.env.APInew_getaccesstoken, {
        tokenuser: this.token,
        url: ''
      }).then((response) => {
        if (response.data.status === 'success') {
          this.progress = false
          this.share_token = response.data.data.url
          this.check_consent(response.data.data.url)
        } else if (response.data.status === 'fail') {
          this.progress = false
          if (response.data.message === 'Autherization fail.') {
            this.$swal({
              text: "ขออภัย autherization ของคุณหมดอายุ กรุณาเข้าสู่ระบบใหม่อีกครั้ง",
              type: "warning",
              showCancelButton: false,
              showConfirmButton: true,
              confirmButtonColor: '#3085d6',
              confirmButtonText: 'ตกลง'
            }).then(result => {
              if (result) {
                this.dialogLogin = true
              }
            })
          } else if (response.data.message === 'not found account') {
            this.$swal({
              text: "ขออภัย ไม่พบข้อมูลผู้ใช้ในระบบ กรุณาเข้าสู่ระบบใหม่อีกครั้ง",
              type: "warning",
              showCancelButton: false,
              showConfirmButton: true,
              confirmButtonColor: '#3085d6',
              confirmButtonText: 'ตกลง'
            }).then(result => {
              if (result) {
                this.dialogLogin = true
              }
            })
          }
        } else {
          this.progress = false
          if (window.innerWidth <= 960) {
            this.$router.push('/mobile/homepage')
          } else {
            this.$router.push('/chat/not_permission')
          }
        }
      }).catch(error => {
        this.progress = false
        console.log(error)
      })
    },
    logout () {
      localStorage.clear()
      if (process.env.LogoutOneid) {
        window.open(process.env.LogoutOneid, '_parent')
      } else {
        this.$router.push({path: '/login', force: true})
      }
    },
    check_consent (token) {
      // console.log(token)
      this.progress = true
      this.axios.post(this.dataConsent.endpoint, {
        tax_id: this.dataConsent.tax_id,
        shared_token: token,
        service_id: this.dataConsent.service_id,
        consent_form_id: this.dataConsent.consent_form_id
        // consent_form_id: null
      }).then((response) => {
        if (response.data.result === 'success') {
          this.progress = false
          this.url_consent = ''
          if (response.data.data.status !== 'approved') {
            this.checkconsentDialog = true
            this.url_consent = response.data.data.response.elements.choice.url + token
            // console.log(response.data.data)
          } else {
            this.updateConsent(this.dataConsent.bot_id)
            if (window.innerWidth <= 960) {
              this.$router.push('/mobile/room/' + this.$route.params.tokenroom)
            } else {
              this.$router.push('/chat/room/' + this.$route.params.tokenroom)
            }
          }
        }
      }).catch(error => {
        console.log(error)
        console.log(error.response !== undefined);
        this.progress = false
        if (error.response !== undefined) {
          if (error.response.data.error === "Cannot read property 'consent_form' of null") {
            // this.getAccesstoken()
            this.check_consent(token)
          } else {
            console.log(error.response.data)
            this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'error')
            if (window.innerWidth <= 960) {
              this.$router.push('/mobile/homepage')
            } else {
              this.$router.push('/chat/homepage')
            }
          }
        } else {
          if (window.innerWidth <= 960) {
            this.$router.push('/mobile/homepage')
          } else {
            this.$router.push('/chat/homepage')
          }
        }

      })
    },
    updateConsent (botid) {
      this.axios.post(process.env.APIalpine + '/api/v1/update-consent-bot', {
        bot_id: botid,
        tokenuser: this.token
      }).then((response) => {
        // update consent
        console.log(`update consent: ${response.data.staus}`)
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>

<style lang="css" scoped>
.layout-height {
  height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/components/homepage/Check_consent.vue